"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));

var _useSystemLinks = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useSystemLinks"));

var _CartContext = _interopRequireDefault(require("../../context/CartContext"));

var _ShopContext = _interopRequireDefault(require("../../context/ShopContext"));

var _Buttons = _interopRequireDefault(require("./Buttons"));

var _CartItem = _interopRequireDefault(require("./CartItem"));

var _Error = _interopRequireDefault(require("./Error"));

var _Price = _interopRequireDefault(require("./Price"));

var _RewardPoints = _interopRequireDefault(require("./RewardPoints"));

var _TotalPrice = _interopRequireDefault(require("./TotalPrice"));

var _Cart = _interopRequireDefault(require("./Cart.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Cart = function Cart(_ref) {
  var _systemLink;

  var _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? "de" : _ref$lang;

  var _useContext = (0, _react.useContext)(_ShopContext.default),
      shopData = _useContext.shopData;

  var _useContext2 = (0, _react.useContext)(_CartContext.default),
      cart = _useContext2.cart;

  var _ref2 = shopData || {},
      rewardPoints = _ref2.rewardPoints;

  var _ref3 = cart || {},
      address = _ref3.address,
      _ref3$isGuest = _ref3.isGuest,
      isGuest = _ref3$isGuest === void 0 ? false : _ref3$isGuest,
      _ref3$items = _ref3.items,
      items = _ref3$items === void 0 ? [] : _ref3$items,
      prices = _ref3.prices,
      _ref3$_loading = _ref3._loading,
      _loading = _ref3$_loading === void 0 ? false : _ref3$_loading;

  var navigate = (0, _useLink.default)();
  var systemLink = (0, _useSystemLinks.default)();
  var css = (0, _Cart.default)();
  var shopUrl = (_systemLink = systemLink("shop")) !== null && _systemLink !== void 0 ? _systemLink : "/";
  var entries = (0, _react.useMemo)(function () {
    var _items$length;

    return (_items$length = items.length) !== null && _items$length !== void 0 ? _items$length : 0;
  }, [items]);

  var handleCheckoutClick = function handleCheckoutClick() {
    if (isGuest && (0, _isEmpty.default)(address)) {
      navigate("/".concat(lang, "/shop/checkout/addresses/guest/new"));
      return;
    }

    navigate("/".concat(lang, "/shop/checkout"));
  };

  var handleShopClick = function handleShopClick() {
    navigate(shopUrl);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: css.cart
  }, entries > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Buttons.default, {
    lang: lang,
    onCheckoutClick: handleCheckoutClick,
    onShopClick: handleShopClick
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.content, "mco-shop-cart-content")
  }, items === null || items === void 0 ? void 0 : items.map(function (item) {
    var guid = item.guid;
    return /*#__PURE__*/_react.default.createElement(_CartItem.default, _extends({
      key: guid,
      lang: lang
    }, item));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.priceWrapper, "mco-shop-cart-price-wrapper")
  }, /*#__PURE__*/_react.default.createElement(_Price.default, {
    lang: lang,
    prices: prices
  }), /*#__PURE__*/_react.default.createElement(_TotalPrice.default, {
    lang: lang,
    prices: prices
  })), !(0, _isEmpty.default)(rewardPoints) && /*#__PURE__*/_react.default.createElement(_RewardPoints.default, {
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_Buttons.default, {
    lang: lang,
    onCheckoutClick: handleCheckoutClick,
    onShopClick: handleShopClick
  }))), entries === 0 && !_loading && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.content, "mco-shop-cart-content")
  }, /*#__PURE__*/_react.default.createElement(_Error.default, {
    lang: lang,
    onClick: handleShopClick
  })));
};

var _default = Cart;
exports.default = _default;